import SadOctopusImage from '../images/sad_octopus.png';

export const SadOctopus = () => (
    <img width={101} src={SadOctopusImage} alt="Sad Flow Club Octopus" />
)